﻿import $ from 'jquery';
import gsap from 'gsap';

function initUniversalAdditionalResourceLazyLoad() {
    //First check to make sure we can use intersection observer. Might drop this in the future since we don't have to support IE11 anymore
    if ("IntersectionObserver" in window) {
        const lazyloadcards = gsap.utils.toArray('.lazy-resources');

        if (lazyloadcards.length != 0) {
            const observerOptions = {
                rootMargin: '300px'
            }

            const imageObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const imageBackgroundTargets = document.querySelectorAll('.lazy-resources .resource-card-image');
                        for (let background of imageBackgroundTargets) {
                            background.style.backgroundImage = `url('${background.dataset.background}')`;
                        }
                        imageObserver.unobserve(entry.target);
                    }
                })
            }, observerOptions)

            lazyloadcards.forEach(function (image) {
                imageObserver.observe(image);
            })
        }
    }
    else {
        //intersection observer doesn't work, so just load in images. This is ie11 fix. 
        var imageBackgroundTargets = $('.lazy-resources .resource-card-image');
        for (var i = 0; i < imageBackgroundTargets.length; i++) {
            var newBackground = imageBackgroundTargets[i].dataset.background
            imageBackgroundTargets[i].style.backgroundImage = 'url(' + newBackground + ')';
        }
    }
}

initUniversalAdditionalResourceLazyLoad();